import { f7, useStore } from 'framework7-react';
import { Router } from 'framework7/types';
import { FC } from 'react';
import { Account } from './Account/Account';
import { LoginInfoState } from '@/config/initialState';
import { store } from '@/config/store';
import { ThemeId } from '@/consts/shop';
import {
  Car,
  Customer,
  NextWarranty,
  PaymentMethod,
  Prepaid,
  Warranty,
} from '@/types/api/customerApi';

interface AccountPageProps {
  f7router: Router.Router;
  status: string;
}
export const AccountPage: FC<AccountPageProps> = ({ f7router, status }) => {
  const themeId = useStore(store, 'getThemeId') as ThemeId;
  const customerInfo = useStore(store, 'customerInfo') as Required<Customer>;
  const paymentMethodsInfo = useStore(
    store,
    'getPaymentMethodsInfo',
  ) as Required<PaymentMethod>[];
  const prepaidInfo = useStore(
    store,
    'getAdvancePaymentsInfo',
  ) as Required<Prepaid>[];
  const loginInfo = useStore(store, 'loginInfo') as LoginInfoState;
  const currentWarranty = useStore(store, 'getCurrentWarranty') as
    | Warranty
    | undefined;
  const nextWarranty = useStore(store, 'getNextWarranty') as
    | NextWarranty
    | undefined;
  const carItemInfo = useStore(store, 'carItemInfo') as Required<Car>;
  const carsInfo = useStore(store, 'carsInfo') as Required<Car>[];

  return (
    <Account
      f7router={f7.views.main.router}
      themeId={themeId}
      status={status}
      customerInfo={customerInfo}
      paymentMethodsInfo={paymentMethodsInfo}
      prepaidInfo={prepaidInfo}
      loginInfo={loginInfo}
      currentWarranty={currentWarranty}
      nextWarranty={nextWarranty}
      carItemInfo={carItemInfo}
      carsInfo={carsInfo}
    />
  );
};
